<template>
  <div class="terminal-management">
    <form @submit.prevent="addTerminal">
      <div class="input-group mb-3">
        <input type="text" class="form-control rounded-left" placeholder="Enter terminal name" v-model="newTerminalName">
        <div class="input-group-append">
          <button type="submit" class="btn btn-primary rounded-right">Add</button>
        </div>
      </div>
    </form>
    <div v-if="unregisteredTerminals.length" class="alert alert-warning text-center">
      <h4>Unregistered Terminals</h4>
      <div v-for="terminal in unregisteredTerminals" :key="terminal.id" class="mb-2">
        <p>{{ terminal.name }} - Enter this code on your kiosk terminal to register: <strong>{{ terminal.pin }}</strong></p>
        <button class="btn btn-danger" @click="confirmDelete(terminal, false)">Delete</button>
      </div>
    </div>
    <ul class="list-group mt-2">
      <a v-for="terminal in registeredTerminals" :key="terminal.id" class="list-group-item d-flex justify-content-between align-items-center">
        <span>
          <!-- Circle indicating connection status -->
          <span :class="['terminal-status', terminal.connected ? 'connected' : 'disconnected']"></span>
          {{ terminal.name }}
        </span>
        <button class="btn btn-danger btn-sm" @click="confirmDelete(terminal, true)">
          <SvgIcon name="delete" />
        </button>
      </a>
    </ul>
  </div>
</template>


<script>
export default {
  data() {
    return {
      newTerminalName: '',
    };
  },
  mounted() {
    this.$store.dispatch('admin/fetchTerminals');
  },
  computed: {
    unregisteredTerminals() {
      return this.terminals?.filter(t => !t.registered) || [];
    },
    registeredTerminals() {
      return this.terminals?.filter(t => t.registered) || [];
    },
    terminals() {
      return this.$store.state.admin.terminals;
    }
  },
  methods: {
    addTerminal() {
      if (this.newTerminalName.trim()) {
        const terminalData = {
          name: this.newTerminalName,
          locationId: this.$store.state.admin.activeLocation
        };
        this.$store.dispatch('admin/addTerminal', terminalData);
        this.newTerminalName = ''; // Clear the input after adding
      }
    },
    confirmDelete(terminal, isRegistered) {
      const message = isRegistered
        ? "Are you sure? This will unlink and reset the terminal. You will need to re-register on premise."
        : "Are you sure you want to delete this terminal?";
      if (confirm(message)) {
        this.$store.dispatch('admin/deleteTerminal', terminal.id);
      }
    },
    saveTerminals() {
      this.$store.dispatch('admin/fetchTerminals');
    }
  }
};
</script>


<style scoped>
.input-group .form-control.rounded-left {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group .btn.rounded-right {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.terminal-status {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 5px;
}

.connected {
  background-color: green;
}

.disconnected {
  background-color: grey;
}
</style>
